export default __webpack_public_path__ + "static/media/course4.8467c0c5.png";